export const refresh = {
  refresh: {
    shape:
      '<path fill="#000" fill-opacity=".98" d="M8.05 12.666c-1.3 0-2.403-.453-3.308-1.358C3.836 10.402 3.383 9.3 3.383 8c0-1.3.453-2.403 1.359-3.309.905-.905 2.008-1.358 3.308-1.358.789 0 1.53.189 2.225.567.694.377 1.253.9 1.675 1.566V3.333h.667v3.483H9.133V6.15H11.6a4.032 4.032 0 0 0-1.475-1.576A3.909 3.909 0 0 0 8.05 4c-1.111 0-2.056.389-2.833 1.166C4.439 5.944 4.05 6.89 4.05 8c0 1.11.389 2.055 1.167 2.833C5.994 11.611 6.939 12 8.05 12c.856 0 1.628-.245 2.317-.734a3.872 3.872 0 0 0 1.45-1.933h.716c-.3 1-.86 1.806-1.683 2.417a4.574 4.574 0 0 1-2.8.916Z"/>',
    viewBox: [0, 0, 16, 16],
  },
};
